<template>
    <div @click="onclick" class="product-item__quick-add--custom">
        <a class="product-item__quick-add__text">Quick Add</a> 
        <span class="product-item__quick-add__plus">+</span>
    </div>
  </template>
  
  <script>
  
  export default {
    props: {
      onclick: {
        type: Function,
      },
    },
  
    computed: {
 
    },
  
    methods: {

    },
  }
  </script>
  
  <style></style>